export async function newPortalVersionReload() {
  const indexUrl = new URL('/index.html', window.location.href);

  try {
    await fetch(indexUrl, { cache: 'reload', credentials: 'same-origin' });
  } catch {
    // Do nothing, we still want to reload the page even if the fetch fails
  }

  window.location.reload();
}
